<!-- ----------------------------------------------- -->
<template>
  <v-card class="com-pc-card tm-pc-info-card">
    <v-row class="com-pc-card-header">
      <div class="com-pc-card-title">{{ text.obsInfo }}</div>
      <div class="tm-pc-info-card-info-area pb-1">
        <v-btn
          v-if="information.length > 0"
          outlined
          x-small
          class="tm-pc-info-color"
          :style="setInfoColor()"
          @click="openInfo()"
        >
          <span>{{ setInfoText() }}</span>
        </v-btn>
      </div>
    </v-row>
    <v-row class="com-pc-card-contents" no-gutters>
      <v-expansion-panels accordion light class="tm-pc-obs-panel">
        <v-expansion-panel>
          <v-expansion-panel-header class="tm-pc-obs-panel-header" expand-icon="arrow_drop_down">
            <v-row class="tm-pc-info-card-info">
              <v-col class="tm-pc-info-card-name-area">
                <v-row no-gutters>
                  <div>
                    <div class="tm-pc-info-card-name-kana">
                      {{ tmCctvList.cctvDetailInfo.cctvNmKana }}
                    </div>
                    <div class="tm-pc-info-card-name">
                      {{ tmCctvList.cctvDetailInfo.cctvNm }}
                    </div>
                  </div>
                  <div class="pl-2">
                    <div class="tm-pc-info-card-name-kana">
                      {{ tmCctvList.cctvDetailInfo.rsysKana
                      }}{{ text.rsysKana }}
                    </div>
                    <div class="tm-pc-info-card-name">
                      {{ tmCctvList.cctvDetailInfo.rsysNm }}{{ text.rsys }}
                    </div>
                  </div>
                  <div class="pl-2">
                    <div class="tm-pc-info-card-name-kana">
                      {{ tmCctvList.cctvDetailInfo.rvrKana }}
                    </div>
                    <div class="tm-pc-info-card-name">
                      {{ tmCctvList.cctvDetailInfo.rvrNm }}
                    </div>
                  </div>
                </v-row>
              </v-col>
            </v-row>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-list dense>
              <!-- 観測所情報 -->
              <v-list-item
                v-for="(item, index) in tmCctvList.obsInfo"
                :key="`obs-${index}`"
              >
                <v-list-item-content>{{ item.title }}</v-list-item-content>
                <v-list-item-content
                  v-if="item.itmkndCd && item.value !== null"
                >
                  <div
                    v-if="item.value[0]"
                    class="tm-pc-link"
                    @click="
                      clickObsList(
                        item.ofcCd[0],
                        item.itmkndCd[0],
                        item.obsCd[0]
                      )
                    "
                  >
                    {{ item.value[0] }}
                    <span class="list-value">{{ item.code[0] }}</span>
                  </div>
                  <div
                    v-if="item.value[1]"
                    class="tm-pc-link"
                    @click="clickSwObsList(item.ofcCd[1], 300, item.obsCd[1])"
                  >
                    {{ item.value[1] }}
                    <span class="list-value">{{ item.code[1] }}</span>
                  </div>
                </v-list-item-content>
                <v-list-item-content
                  v-else-if="item.itmkndCd && item.value === null"
                >
                  <div>
                    {{ noData }}
                  </div>
                </v-list-item-content>
                <v-list-item-content v-else>
                  <div style="line-break: strict">
                    <span class="list-value">{{ item.value }}</span>
                    <span class="list-unit">{{ item.unit }}</span>
                    <span class="list-value">{{ item.code }}</span>
                  </div>
                </v-list-item-content>
              </v-list-item>
              <!-- コード値 -->
              <v-list-item
                v-for="(item, index) in codeInfo"
                :key="`cd-${index}`"
              >
                <v-list-item-content>{{ item.title }}</v-list-item-content>
                <v-list-item-content>
                  <div>
                    <span class="list-value">{{ item.value }}</span>
                    <span class="list-unit">{{ item.unit }}</span>
                  </div>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-row>
  </v-card>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 [PC]河川カメラ 観測所情報カード
 * TmCctvInfo.vue
 * @author ILUKE
 */

import mixin from "./../../lib/mixin.js";

export default {
  name: "tm-cctv-info",
  mixins: [mixin],
  data() {
    return {
      /** 文字列リソース */
      text: {
        info: "お知らせ",
        obsInfo: "観測所情報",
        obsType: "河川カメラ",
        rsys: "水系",
        rsysKana: "すいけい",
      },
      noData: "--",
    };
  },
  created() {
    this.$store.dispatch("map/getObsScamInformation", {
      scamId: this.$store.state.Telemeter.selectedTmParam.scamId,
    });
  },
  computed: {
    /**
     * 河川カメラ情報 取得
     */
    tmCctvList: {
      get() {
        return this.$store.state.Telemeter.selectedTm;
      },
    },
    /**
     * コード値 取得
     */
    codeInfo: {
      get() {
        return this.$store.state.Telemeter.selectedTm.codeInfo;
      },
    },
    /**
     * お知らせ情報全件取得
     */
    information: {
      get() {
        return this.$store.state.map.information;
      },
    },
    /** お知らせのタイトルと色 */
    titleSummaryCode: {
      get() {
        return this.$store.state.info.titleSummaryCode;
      },
    },
    /** お知らせ設定情報 */
    infoConfig: {
      get() {
        return this.$store.state.info.informationConfig;
      },
    },
  },
  methods: {
    /** お知らせ情報表示 */
    openInfo() {
      if (this.$store.state.map.showInformation === false) {
        if (this.information.length === 1) {
          // 1件のみの場合は直接遷移する
          this.linkInfoUrl(this.information[0].infoManageCode);
        } else {
          this.$store.commit("map/showInformation");
        }
      } else {
        this.$store.commit("map/hideInfoRw");
      }
    },
    /** 観測所リンク */
    clickObsList(ofcCd, itmkndCd, obsCd) {
      this.$log.debug(
        "[rp/TmList] clickObsList(" + ofcCd + "," + itmkndCd + "," + obsCd + ")"
      );
      // 選択中テレメータ情報を設定
      this.$store.commit("Telemeter/setSelectedTmParam", {
        ofcCd: ofcCd,
        itmkndCd: itmkndCd,
        obsCd: obsCd,
      });
      // 画面遷移
      this.routerPushTm("/pc/tm");
    },
    /** 危機管理観水位測所画面へ遷移 */
    clickSwObsList(swofcCd, itmkndCd, swobsCd) {
      this.$log.debug(
        "[rp/TmList] clickSwObsList(" +
          swofcCd +
          "," +
          itmkndCd +
          "," +
          swobsCd +
          ")"
      );
      // 選択中テレメータ情報を設定
      this.$store.commit("Telemeter/setSelectedTmParam", {
        ofcCd: null,
        itmkndCd: 300,
        obsCd: null,
      });
      this.$store.commit("Swin/setSelectedSwParam", {
        swofcCd: swofcCd,
        itmkndCd: itmkndCd,
        swobsCd: swobsCd,
      });
      // 画面遷移
      this.routerPushTmSw("/pc/tm");
    },
    /** お知らせボタン 文字 */
    setInfoText() {
      if (this.titleSummaryCode.pcText !== undefined) {
        return this.titleSummaryCode.pcText;
      } else {
        return this.text.info;
      }
    },
    /** お知らせボタン 着色 */
    setInfoColor() {
      if (this.infoConfig.titleSummaryCode !== undefined) {
        if (
          this.titleSummaryCode.backGroundColor !== undefined &&
          this.titleSummaryCode.textColor !== undefined
        ) {
          return {
            backgroundColor: this.titleSummaryCode.backGroundColor,
            color: this.titleSummaryCode.textColor
          };
        } else {
          // 設定ファイルにないsummaryCodeの場合、その他(summaryCode=5で着色)
          const code = 5;
          return {
            backgroundColor: this.infoConfig.titleSummaryCode[code].backGroundColor,
            color: this.infoConfig.titleSummaryCode[code].textColor
          }
        }
      } else {
        // 設定ファイルにtitleSummaryCodeが無い場合
        return {
          backgroundColor: "#ffffff",
          color: "#000000"
        }
      }
    },
    linkInfoUrl(infoManageCd) {
      let infoDetailUrl = this.$router.resolve({
        path: "/pcfull/info/detail",
        query: {
          infmgcd: infoManageCd,
          fld: this.$store.state.app.fldCtlParty,
        },
      });
      window.open(infoDetailUrl.href, "_blank");
    },
  },
  /** 監視部 */
  watch: {
    information() {  
      // お知らせが1件以上存在する場合、色とテキストを判定
      if (this.information.length > 0) {
        this.$store.dispatch("info/getInfoTitleColor", {
          information: this.information,
        });
      }

      // お知らせダイアログ非表示
      this.$store.commit("map/hideInfoRw");
    },
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped></style>
